import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ReservedLayout } from "@/components/ReservedLayout";
import "@/App.css";

// Accesso (unica porta d'ingresso - uso interno)
import Login from "@/pages/Login";

// Reserved
import Dashboard from "@/pages/Dashboard";
import Centralino from "@/pages/Centralino";
import Persons from "@/pages/Persons";
import PersonDetail from "@/pages/PersonDetail";
import Organizations from "@/pages/Organizations";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import Diario from "@/pages/Diario";
import Tasks from "@/pages/Tasks";
import Accessi from "@/pages/Accessi";
import Agenda from "@/pages/Agenda";
import Services from "@/pages/Services";
import Entities from "@/pages/Entities";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import AIAssistant from "@/pages/AIAssistant";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Home = Login (applicazione ad uso esclusivamente interno) */}
            <Route path="/" element={<Login />} />
            <Route path="/accedi" element={<Navigate to="/" replace />} />

            {/* Area riservata */}
            <Route path="/app" element={<ProtectedRoute><ReservedLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="centralino" element={<Centralino />} />
              <Route path="persone" element={<Persons />} />
              <Route path="persone/:id" element={<PersonDetail />} />
              <Route path="organizzazioni" element={<Organizations />} />
              <Route path="pratiche" element={<Cases />} />
              <Route path="pratiche/:id" element={<CaseDetail />} />
              <Route path="diario" element={<Diario />} />
              <Route path="attivita" element={<Tasks />} />
              <Route path="accessi" element={<Accessi />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="servizi" element={<Services />} />
              <Route path="enti" element={<Entities />} />
              <Route path="documenti" element={<Documents />} />
              <Route path="report" element={<Reports />} />
              <Route path="assistente-ai" element={<AIAssistant />} />
              <Route path="notifiche" element={<Notifications />} />
              <Route path="amministrazione" element={<Admin />} />
              <Route path="profilo" element={<Profile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
